import React from 'react';
import {
  AppLayout,
  SkeletonRequestQuote,
} from 'sections/services-marketplace/experts/components';
import {
  SkeletonExpertDetails,
  SkeletonServiceDetails,
  SkeletonReviews,
} from '../components';

export function ProfileListingSkeleton() {
  return (
    <AppLayout>
      <AppLayout.Container slim>
        <AppLayout.Section size="TwoThirds">
          <SkeletonExpertDetails />
          <SkeletonServiceDetails />
          <SkeletonReviews />
        </AppLayout.Section>
        <AppLayout.Section size="OneThird">
          <SkeletonRequestQuote />
        </AppLayout.Section>
      </AppLayout.Container>
    </AppLayout>
  );
}
